<template>
	<div class="study">
		<publicHeader @child-event="parentEvent"></publicHeader>
		<personalHeader :myInfo="myInfo"></personalHeader>
		
		<div class="personal bg_gray">
			<div class="w1200 flex">
				<personalNav :current="current"></personalNav>
				<div class="personal_r bg_white radius8">
					<div class="personal_title mab20">
						<i class="f20px cl_dark mar10">基本资料</i>
						<span class="cl_gray mal10">以下资料可用于密码找回，手机绑定等服务，请务必准确填写并牢记</span>
					</div>
					<div class="personal_div">
						<div class="personal_item" v-if="myInfo.name != null">
							<p class="personal_item_l f16px cl_gray"><span class="inline">账号</span><i class="inline">：</i></p>
							<div class="personal_item_r">
								<span class="personal_item_name f16px">{{myInfo.name}}</span>
								<!-- <i class="cl_gray personal_item_tip">（3-20个字符，支持字母和数字，账号设置后不能更改，请慎重。）</i> -->
							</div>
						</div>
						<div class="personal_item" v-if="myInfo.is_test == 0">
							<p class="personal_item_l f16px cl_gray"><span class="inline">手机</span><i class="inline">：</i></p>
							<div class="personal_item_r">
								<span class="personal_item_name f16px">{{myInfo.phone == ''||myInfo.phone == null  ? '未绑定手机' : myInfo.phone}}</span>
								<router-link to="/phone" class="cl_blue">{{myInfo.phone == ''||myInfo.phone == null ? '绑定手机>' : '更换手机>'}}</router-link>
							</div>
						</div>
						<!-- <div class="personal_item" v-if="myInfo.wx_nickname != '' && myInfo.is_test == 0">
							<p class="personal_item_l f16px cl_gray"><span class="inline">昵称</span><i class="inline">：</i></p>
							<div class="personal_item_r">
								<div class="personal_name">
									<div class="personal_name_show" v-if="inputShow == false">
										<span class="inline">{{myInfo.wx_nickname}}</span>
										<i class="cl_blue inline" @click.stop="nikeEdit">修改></i>
									</div>
									<div class="personal_name_hide" v-if="inputShow == true">
										<input type="text" v-model="personalName" ref="nick" @change="nikeInput" @blur="nikeBlur" />
									</div>
								</div>
							</div>
						</div> -->
					</div>
					<div class="personal_title mab20 mat30" v-if="myInfo.school_name != '' && myInfo.is_test == 0">
						<i class="f20px cl_dark">我的班级</i>
						<span class="cl_gray"></span>
					</div>
					<div class="personal_div" v-if="myInfo.school_name != '' && myInfo.is_test == 0">
						<div class="personal_item">
							<p class="personal_item_l f16px cl_gray"><span class="inline">学校</span><i class="inline">：</i></p>
							<div class="personal_item_r">
								<span class="personal_item_name f16px">{{myInfo.school_name == '' ? '未加入学校' : myInfo.school_name}}</span>
								<router-link to="" class="cl_blue">{{myInfo.school_name == '' ? '加入学校>' : ''}}</router-link>
							</div>
						</div>
						<div class="personal_item" v-if="myInfo.role != 'teacher'">
							<p class="personal_item_l f16px cl_gray"><span class="inline">班级</span><i class="inline">：</i></p>
							<div class="personal_item_r">
								<span class="personal_item_name f16px">{{myInfo.class_name == '' || myInfo.class_name == null ? '未加入班级' : myInfo.class_name}}</span>
								<router-link to="/my_class" class="cl_blue">{{myInfo.class_name == '' || myInfo.class_name == null ? '加入班级>' : '更换班级>'}}</router-link>
							</div>
						</div>
						<div class="personal_item" v-if="myInfo.class_id != '' || myInfo.class_id != null">
							<p class="personal_item_l f16px cl_gray"><span class="inline">真实姓名</span><i class="inline">：</i></p>
							<div class="personal_item_r">
								<span class="personal_item_name f16px">{{myInfo.real_name == '' ? '未填写' : myInfo.real_name}}</span>
								<router-link to="/my_info" class="cl_blue" v-if="myInfo.role != 'teacher'">编辑姓名></router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import vfooter from '../../components/footer.vue'
	import personalHeader from '../../components/personal_header.vue'
	import personalNav from '../../components/personal_nav.vue'
	export default {
	  name: 'personal',
		components: {
			publicHeader,
			vfooter,
			personalHeader,
			personalNav,
		},
	  props: {
	    
	  },
		data () {
			return {
				myInfo: {},
				current: {
					navCur: 1,
					listCur: 1,
				},
				inputShow: false,
				personalName: "",
			}
		},
		mounted() {
			var that = this;
			document.getElementsByTagName('body')[0].onclick = function () {
				that.inputShow = false;
			};
		},
		created() {
			
		},
		methods: {
			parentEvent (data) {
				this.myInfo = data;
				this.personalName = this.myInfo.wx_nickname;
			},
			nikeEdit () {
				this.inputShow = true;
				this.$nextTick(()=>{
					this.$refs.nick.focus();
				})
			},
			nikeInput (e) {
				this.myInfo.wx_nickname = e.target.value;
			},
			nikeBlur (e) {
				this.$get("/api/user/post_wx_nickname_edit",{
					wx_nickname: e.target.value,
					token: localStorage.getItem("token"),
				})
				.then(res => {
					
				});
			},
			
		},
	}
</script>

<style>
</style>
